module.exports = __webpack_public_path__ + "img/berichte.4e706e10.svg";